import { FiLogOut as LogOutIcon, FiMenu as MenuIcon, FiSearch as SearchIcon, FiChevronDown, FiUser } from "react-icons/fi";
import { IoChatbubbleEllipsesOutline } from "react-icons/io5";
import { useEffect, useState, useRef, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { MdOutlineErrorOutline } from "react-icons/md";
import NotificationDropdown from "./NotificationDropdown";
import { logout, logoutUser, User } from "../../Redux/Slice/Auth";
import { setChatDrawerOpen, syncCurrentPermissions } from "../../Redux/Slice/ChatSlice";
import defaultProfile from "../../Image/Daynamic_Logo_Piture.png";
import Cookies from "js-cookie";
import { createPortal } from "react-dom";
const ownerPages = [
  { name: "Home", path: "/" },
  { name: "Owner Chat Management", path: "/owner-chat" },
  { name: "Party call details", path: "/Partycalldetails" },
  { name: "Task Master", path: "/taskmaster" },
  { name: "Sub Task", path: "/subtask" },
  { name: "Show All Task", path: "/ShowAllTask" },
  { name: "Emp Profile", path: "/EmpProfile" },
  { name: "Daily Report", path: "/DailyReport" },
  { name: "Monthly Report", path: "/MonthlyReport" },
  { name: "Emp Productivity", path: "/TaskReport" },
  { name: "Emp Work Status", path: "/TaskDetail" },
  { name: "Daily Work Verification", path: "/TaskTimeingReport" },
  { name: "Inhouse RND", path: "/InhouseRnd" },
  { name: "Assign Task", path: "/AssignTask" },
  { name: "Add Member", path: "/AddMember" },
  { name: "Employee Details", path: "/EmpOldDetails" },
  { name: "Show All Member", path: "/ShowAllMember" },
  { name: "Add Customer", path: "/AddCustomer" },
  { name: "Show All Customers", path: "/ShowAllCustomers" },
  { name: "Leave Inbox", path: "/OwnerLeaveInbox" },
  { name: "Employee History", path: "/EmployeeHistory" },
  { name: "Attendance Corrections", path: "/AttendanceCorrections" },
  { name: "Payroll", path: "/Payroll" },
  { name: "Workforce Dashboard", path: "/AttendanceDashboard" },
  { name: "View Client", path: "/View_Client" },
  { name: "Wp Registration", path: "/WhatsApp_Registration" },
  { name: "View Wp Registation", path: "/View_WpRegistration" },
  { name: "Client Detail", path: "/WpSetupDetail" },
  { name: "Slab", path: "/Slab" },
  { name: "Slab Detail", path: "/Slab_Detail" },
  { name: "Log Report", path: "/LogReport" },
  { name: "WP Api Main", path: "/WpSetup_Main" },
  { name: "WP Api Details", path: "/WpSetup_Details" },
  { name: "Doc Link Main", path: "/DocumentLink_main" },
  { name: "DT Link Details", path: "/DocumentLink_Details" },
  { name: "Add Template", path: "/Add_Template" },
  { name: "View Template", path: "/View_Template" },
  { name: "Project", path: "/Project" },
  { name: "Data Transfer", path: "/DataTransfer" },
  { name: "Add Registration", path: "/Add_Registration" },
  { name: "View Registration", path: "/View_Registration" },
  { name: "Add Version", path: "/Add_Version" },
  { name: "View Version", path: "/View_Version" },
  { name: "OCR Plan", path: "/Ocr_Plan" },
  { name: "Inward Logs", path: "/Inward_Logs" },
  { name: "Delivery Logs", path: "/Delivery_Logs" },
  { name: "Sign Copy Receive", path: "/SignCopyRcv" },
  { name: "DataBase Update", path: "/DbUpdate" },
  { name: "Exe Update", path: "/ExeUpdate" },
  { name: "Exel Update", path: "/ExelUpdate" },
  { name: "Setup Main", path: "/Einvoice_Eway_Setup_Main" },
  { name: "Setup Details", path: "/Einvoice_Eway_Setup_Details" },
  { name: "Setup Registration", path: "/Einvoice_Eway_Setup_Registration" },
  { name: "E-Invoice & E-Way Log", path: "/EInvoice_Eway_Log" },
  { name: "Invoice & Way Response", path: "/EInvoice_Eway_Response" },
  { name: "GSTIN Setup", path: "/GstIn_Setup" },
  { name: "GeoResolver", path: "/GeoResolver_Setup" }
];

const seniorDeveloperPages = [
  { name: "Home", path: "/" },
  { name: "Main Task", path: "/MainTask" },
  { name: "Task Master", path: "/taskmaster" },
  { name: "Sub Task", path: "/SubTask" },
  { name: "Sub Task Master", path: "/subtaskmaster" },
  { name: "Customer Request", path: "/CustomerReq" },
  { name: "Inhouse RND", path: "/InhouseRnd" },
  { name: "Assign Task", path: "/AssignTask" },
  { name: "Show All Task", path: "/ShowAllTask" },
  { name: "Emp Profile", path: "/EmpProfile" },
  { name: "Daily Report", path: "/DailyReport" },
  { name: "Monthly Report", path: "/MonthlyReport" },
  { name: "Emp Productivity", path: "/TaskReport" },
  { name: "Emp Work Status", path: "/TaskDetail" },
  { name: "Add Member", path: "/AddMember" },
  { name: "Show All Member", path: "/ShowAllMember" },
  { name: "Add Customer", path: "/AddCustomer" },
  { name: "Show All Customers", path: "/ShowAllCustomers" },
  { name: "GM Request", path: "/GeneralManagerRequest" },
  { name: "Leave Request", path: "/ProjectManagerRequest" },
  { name: "Payroll", path: "/Payroll" },
  { name: "Workforce Dashboard", path: "/AttendanceDashboard" },
  { name: "Report", path: "/Report" },
  { name: "View Client", path: "/View_Client" },
  { name: "Wp Registration", path: "/WhatsApp_Registration" },
  { name: "View Wp Registation", path: "/View_WpRegistration" },
  { name: "Client Detail", path: "/WpSetupDetail" },
  { name: "Slab", path: "/Slab" },
  { name: "Slab Detail", path: "/Slab_Detail" },
  { name: "Log Report", path: "/LogReport" },
  { name: "WP Api Main", path: "/WpSetup_Main" },
  { name: "WP Api Details", path: "/WpSetup_Details" },
  { name: "Doc Link Main", path: "/DocumentLink_main" },
  { name: "DT Link Details", path: "/DocumentLink_Details" },
  { name: "Add Template", path: "/Add_Template" },
  { name: "View Template", path: "/View_Template" },
  { name: "Project", path: "/Project" },
  { name: "Data Transfer", path: "/DataTransfer" },
  { name: "Add Registration", path: "/Add_Registration" },
  { name: "View Registration", path: "/View_Registration" },
  { name: "Add Version", path: "/Add_Version" },
  { name: "View Version", path: "/View_Version" },
  { name: "OCR Plan", path: "/Ocr_Plan" },
  { name: "Inward Logs", path: "/Inward_Logs" },
  { name: "Delivery Logs", path: "/Delivery_Logs" },
  { name: "Sign Copy Receive", path: "/SignCopyRcv" },
  { name: "DataBase Update", path: "/DbUpdate" },
  { name: "Exe Update", path: "/ExeUpdate" },
  { name: "Exel Update", path: "/ExelUpdate" },
  { name: "Setup Main", path: "/Einvoice_Eway_Setup_Main" },
  { name: "Setup Details", path: "/Einvoice_Eway_Setup_Details" },
  { name: "Setup Registration", path: "/Einvoice_Eway_Setup_Registration" },
  { name: "E-Invoice & E-Way Log", path: "/EInvoice_Eway_Log" },
  { name: "Invoice & Way Response", path: "/EInvoice_Eway_Response" },
  { name: "GSTIN Setup", path: "/GstIn_Setup" },
  { name: "GeoResolver", path: "/GeoResolver_Setup" }
];

const Header = ({ toggleSidebar, isSidebarOpen }) => {
  const dispatch = useDispatch();

  const loginData = Cookies.get("loginData");
  const PersonData = loginData ? JSON.parse(loginData) : null;
  const { isdata } = useSelector((state) => state.auth);

  const role = PersonData?.data?.Role || isdata?.data?.Role || "";
  const isOwner = role.toLowerCase() === "owner";
  const isDelphiSenior = role === "Delphi Senior Developer";
  const isAllowedSearch = isOwner || isDelphiSenior;

  const dispatchCalled = useRef(false);
  useEffect(() => {
    if (!isdata && PersonData?.data?._id && !dispatchCalled.current) {
      dispatchCalled.current = true;
      dispatch(User(PersonData.data._id));
    }
  }, [dispatch, isdata, PersonData?.data?._id]);

  useEffect(() => {
    if (isdata?.data) {
      dispatch(syncCurrentPermissions({
        chatEnabled: isdata.data.chatEnabled,
        sendEnabled: isdata.data.sendEnabled
      }));
    }
  }, [isdata, dispatch]);


  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [showDailyWorkModal, setShowDailyWorkModal] = useState(false);
  const [showConfirmLogoutModal, setShowConfirmLogoutModal] = useState(false);
  const navigate = useNavigate(); // React Router navigation
  const dropdownRef = useRef(null);

  // Click outside to close profile dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // States for page finder modal
  const [isPageModalOpen, setIsPageModalOpen] = useState(false);
  const [pageSearchQuery, setPageSearchQuery] = useState("");

  // Keyboard shortcut listener (Ctrl+K / Cmd+K to open, Escape to close)
  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "k") {
        if (!isAllowedSearch) return;
        e.preventDefault();
        setIsPageModalOpen((prev) => !prev);
      }
      if (e.key === "Escape") {
        setIsPageModalOpen(false);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isAllowedSearch]);

  // Memoized page filtering showing all pages for the role
  const filteredPages = useMemo(() => {
    const pages = isOwner ? ownerPages : isDelphiSenior ? seniorDeveloperPages : [];
    if (!pageSearchQuery) {
      return pages;
    }
    const query = pageSearchQuery.toLowerCase();
    return pages.filter(page =>
      page.name.toLowerCase().includes(query) ||
      page.path.toLowerCase().includes(query)
    );
  }, [pageSearchQuery, isOwner, isDelphiSenior]);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleLogoutClick = () => {
    setIsDropdownOpen(false);
    setShowConfirmLogoutModal(true);
  };

  const confirmLogout = () => {
    const userId = PersonData?.data?._id;

    if (!userId) {
      // If already cleared, just redirect
      setShowConfirmLogoutModal(false);
      navigate("/");
      return;
    }

    dispatch(logoutUser(userId)).then((res) => {
      setShowConfirmLogoutModal(false);
      if (res.meta.requestStatus === "rejected") {
        setShowDailyWorkModal(true);
      } else {
        navigate("/"); // Redirect to login or root only if successful
      }
    });
  };

  // Chat permissions & unread messaging indicators
  const chatAccess = isdata?.data?.chatEnabled !== false;
  const conversations = useSelector((state) => state.chat.conversations || []);
  const totalUnreadChat = conversations.reduce((total, conv) => total + (conv.unreadCount || 0), 0);

  return (
    <header
      className="Main_TopHeader_bg_color text-white py-2.5 px-3 sm:px-4 lg:px-6 flex justify-between items-center rounded-xl sm:rounded-2xl m-2 sm:m-4 shadow-2xl border border-white/10 transition-all duration-300 relative z-40"
      style={{
        backgroundColor: "rgba(19, 58, 105, 0.92)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
      }}
    >
      {/* Sidebar toggle button */}
      <button
        onClick={toggleSidebar}
        className="text-white/80 focus:outline-none hover:bg-white/10 p-2 rounded-xl transition-all duration-300 hover:scale-105 active:scale-95 cursor-pointer"
        aria-label={isSidebarOpen ? "Close sidebar" : "Open sidebar"}
        title={isSidebarOpen ? "Close Sidebar" : "Open Sidebar"}
      >
        <MenuIcon size={22} />
      </button>

      {/* Title */}
      <h1 className="text-xl font-extrabold hidden lg:block text-white tracking-wide">
        Task Management
      </h1>

      {/* Search, Notification, User */}
      <div className="flex items-center space-x-2 sm:space-x-4">
        {/* Searchable Page Quick Switcher Button */}
        {isAllowedSearch && (
          <button
            onClick={() => setIsPageModalOpen(true)}
            className="flex items-center justify-center gap-2 bg-white/5 hover:bg-white/15 text-white/90 hover:text-white text-xs font-semibold rounded-full py-1.5 px-4 border border-white/10 hover:border-white/25 transition-all duration-300 hover:scale-[1.02] shadow-sm hover:shadow-md cursor-pointer"
            title="Search and jump to any page (Ctrl + K)"
          >
            <SearchIcon size={14} className="text-white/85" />
            <span className="hidden sm:inline tracking-wide">Search Page...</span>
            <kbd className="hidden md:inline-flex items-center gap-0.5 pointer-events-none select-none text-[9px] font-mono text-white/60 bg-white/5 px-2 py-0.5 rounded-md border border-white/10 ml-2 shadow-sm">
              Ctrl+K
            </kbd>
          </button>
        )}

        {/* Chat Drawer Toggle Icon */}
        {chatAccess && (
          <button
            onClick={() => dispatch(setChatDrawerOpen(true))}
            className="relative p-2.5 text-white/85 hover:text-white hover:bg-white/10 rounded-full transition-all duration-300 hover:scale-105 active:scale-95 focus:outline-none cursor-pointer flex items-center justify-center mr-1"
            title="Open Chat"
          >
            <IoChatbubbleEllipsesOutline size={22} />
            {totalUnreadChat > 0 && (
              <span className="absolute top-0 right-0 min-w-[18px] h-[18px] px-1 bg-gradient-to-r from-red-500 to-rose-600 border-2 border-[#133A69] rounded-full text-white text-[9px] font-bold flex items-center justify-center transform translate-x-1/4 -translate-y-1/4 animate-pulse shadow-md">
                {totalUnreadChat > 99 ? '99+' : totalUnreadChat}
              </span>
            )}
          </button>
        )}

        {/* Notification */}
        <NotificationDropdown />

        {/* Profile Dropdown */}
        <div className="relative" ref={dropdownRef}>
          <div
            className="flex items-center space-x-2.5 cursor-pointer bg-white/5 hover:bg-white/15 pl-1.5 pr-3.5 py-1.5 rounded-full transition-all duration-300 border border-white/10 hover:border-white/25 shadow-sm hover:shadow-md select-none active:scale-[0.97]"
            onClick={toggleDropdown}
          >
            <div className="relative">
              <img
                src={(isdata?.data?.ProfilePhoto || PersonData?.data?.ProfilePhoto) || defaultProfile}
                alt="User Avatar"
                className="w-8 h-8 rounded-full ring-2 ring-white/20 object-cover shadow-inner transition-transform duration-300 hover:scale-105"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = defaultProfile;
                }}
              />
            </div>
            <div className="hidden sm:flex flex-col items-start min-w-0 text-left">
              <span className="text-xs font-bold text-white/95 leading-tight truncate max-w-[110px] tracking-wide">
                {isdata?.data?.Name || PersonData?.data?.Name || "User"}
              </span>
              <span className="text-[8px] text-white/60 font-semibold uppercase tracking-widest leading-none mt-0.5 truncate max-w-[110px]">
                {isdata?.data?.Role || PersonData?.data?.Role || "Team Member"}
              </span>
            </div>
            <FiChevronDown size={12} className={`text-white/50 transition-transform duration-300 ${isDropdownOpen ? "rotate-180" : ""}`} />
          </div>

          {isDropdownOpen && (
            <div className="absolute right-0 mt-3 w-60 bg-white/95 backdrop-blur-md rounded-2xl shadow-[0_20px_50px_rgba(15,23,42,0.15)] border border-slate-100/80 py-1.5 z-40 animate__animated animate__fadeInUp animate__faster">
              {/* Dropdown Profile Preview - Minimal & Clean */}
              <div className="px-4 py-4 flex items-center gap-3 border-b border-slate-100/60 select-none">
                <img
                  src={(isdata?.data?.ProfilePhoto || PersonData?.data?.ProfilePhoto) || defaultProfile}
                  alt="User Avatar"
                  className="w-11 h-11 rounded-full object-cover border-2 border-slate-100 shadow-md ring-2 ring-blue-500/10"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = defaultProfile;
                  }}
                />
                <div className="flex flex-col min-w-0">
                  <span className="text-xs font-bold text-slate-800 truncate tracking-wide">
                    {isdata?.data?.Name || PersonData?.data?.Name || "User"}
                  </span>
                  <span className="inline-block self-start mt-1 text-[8px] font-bold bg-blue-50 text-blue-700 px-2 py-0.5 rounded-full uppercase tracking-wider truncate max-w-[140px]">
                    {isdata?.data?.Role || PersonData?.data?.Role || "Team Member"}
                  </span>
                </div>
              </div>

              {/* Menu Options */}
              <div className="p-1.5 space-y-1">
                <button
                  onClick={() => {
                    setIsDropdownOpen(false);
                    navigate("/login-activity");
                  }}
                  className="flex items-center w-full px-3.5 py-2.5 text-xs font-semibold text-slate-600 hover:bg-slate-50 hover:text-slate-800 rounded-xl transition-all duration-200 cursor-pointer border-none group"
                >
                  <FiUser size={15} className="mr-2.5 text-slate-400 group-hover:text-slate-600 transition-colors group-hover:scale-110 duration-200" />
                  Security & Login
                </button>
                <button
                  onClick={handleLogoutClick}
                  className="flex items-center w-full px-3.5 py-2.5 text-xs font-semibold text-slate-600 hover:bg-rose-50/60 hover:text-rose-600 rounded-xl transition-all duration-200 cursor-pointer border-none group"
                >
                  <LogOutIcon size={15} className="mr-2.5 text-slate-400 group-hover:text-rose-500 transition-colors group-hover:scale-110 duration-200" />
                  Logout
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Daily Work Incomplete Modal */}
      {showDailyWorkModal && createPortal(
        <>
          {/* Backdrop covering the entire viewport */}
          <div
            onClick={() => setShowDailyWorkModal(false)}
            className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[99998]"
          />

          {/* Modal Card centered in the viewport */}
          <div
            className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[99999] bg-white rounded-2xl shadow-[0_10px_40px_rgba(0,0,0,0.2)] w-[90%] max-w-[420px] overflow-hidden border-[1.5px] border-[#e23b49] flex flex-col items-center pt-8 pb-6 px-6"
          >
            {/* Red Circle with Cross */}
            <div className="bg-[#e23b49] rounded-full flex items-center justify-center w-[75px] h-[75px] mb-4">
              <MdOutlineErrorOutline className="text-white text-4xl" />
            </div>

            {/* Heading */}
            <h2 className="text-[22px] font-bold text-[#e23b49] mb-5 tracking-wide">Logout Failed</h2>

            {/* Error Message Box */}
            <div className="w-full border border-gray-100 bg-gray-50/50 rounded-lg p-3.5 mb-6 shadow-sm flex items-center justify-center">
              <span className="text-[#334155] text-[15px] font-medium tracking-wide text-center">
                Please complete your daily work in the portal before logging out.
              </span>
            </div>

            {/* Close Button */}
            <button
              onClick={() => setShowDailyWorkModal(false)}
              className="px-8 py-2.5 bg-[#e23b49] hover:bg-[#cc3441] text-white rounded-lg font-bold text-[16px] shadow-sm transition-all duration-200 active:scale-95 cursor-pointer"
            >
              Close
            </button>
          </div>
        </>,
        document.body
      )}

      {/* Confirm Logout Modal */}
      {showConfirmLogoutModal && createPortal(
        <>
          {/* Backdrop covering the entire viewport */}
          <div
            onClick={() => setShowConfirmLogoutModal(false)}
            className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[99998]"
          />

          {/* Modal Card centered in the viewport */}
          <div
            className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[99999] bg-white rounded-3xl shadow-[0_25px_60px_rgba(0,0,0,0.15)] w-[90%] max-w-[400px] border border-slate-100 flex flex-col items-center pt-8 pb-7 px-6 overflow-visible"
          >
            {/* Elegant Logout Icon Circle */}
            <div className="bg-rose-50 text-rose-600 rounded-full flex items-center justify-center w-[72px] h-[72px] mb-5 border border-rose-100 shadow-sm">
              <LogOutIcon className="text-3xl" />
            </div>

            {/* Heading */}
            <h2 className="text-xl font-black text-slate-800 mb-2 tracking-tight">Log Out</h2>

            {/* Message */}
            <p className="text-slate-500 text-sm mb-8 text-center leading-relaxed">
              Are you sure you want to log out from your account?
            </p>

            {/* Buttons */}
            <div className="flex w-full gap-3">
              <button
                onClick={() => setShowConfirmLogoutModal(false)}
                className="flex-1 py-3 border border-slate-200 text-slate-600 hover:bg-slate-50 rounded-2xl font-bold text-sm transition-all duration-200 active:scale-95 cursor-pointer"
              >
                No, Stay
              </button>
              <button
                onClick={confirmLogout}
                className="flex-1 py-3 bg-rose-600 hover:bg-rose-700 text-white rounded-2xl font-bold text-sm shadow-md shadow-rose-500/10 transition-all duration-200 active:scale-95 cursor-pointer"
              >
                Yes, Logout
              </button>
            </div>
          </div>
        </>,
        document.body
      )}

      {/* 🧭 SPOTLIGHT SEARCH PAGE FINDER MODAL */}
      {isPageModalOpen && (
        <div
          className="fixed inset-0 z-[100000] flex items-start justify-center pt-[12vh] bg-slate-900/60 backdrop-blur-xs px-4"
          onClick={() => {
            setIsPageModalOpen(false);
            setPageSearchQuery("");
          }}
        >
          <div
            className="bg-white border-2 border-[#133a69] rounded-2xl w-full max-w-[550px] shadow-[0_25px_60px_rgba(19,58,105,0.25)] overflow-hidden flex flex-col max-h-[70vh]"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Modal Input Search Header */}
            <div className="relative flex items-center p-4 border-b border-slate-100 bg-[#f3f8fb]">
              <SearchIcon size={18} className="absolute left-7 text-[#133a69] pointer-events-none" />
              <input
                autoFocus
                type="text"
                placeholder="Where would you like to go?"
                value={pageSearchQuery}
                onChange={(e) => setPageSearchQuery(e.target.value)}
                className="w-full bg-white text-slate-800 placeholder-slate-400 text-sm font-semibold rounded-xl py-3 pl-12 pr-16 focus:outline-none border border-slate-200 focus:border-[#133a69] focus:ring-2 focus:ring-[#133a69]/10 transition-all"
              />
              <div className="absolute right-7 flex items-center gap-2">
                <kbd className="hidden sm:inline-flex text-[9px] font-mono text-slate-500 bg-white px-1.5 py-0.5 rounded border border-slate-200 shadow-sm">
                  ESC
                </kbd>
                <button
                  onClick={() => {
                    setIsPageModalOpen(false);
                    setPageSearchQuery("");
                  }}
                  className="text-[#133a69] hover:text-red-650 transition-colors text-xl font-bold"
                >
                  &times;
                </button>
              </div>
            </div>

            {/* Modal Body: Results List */}
            <div className="flex-1 overflow-y-auto py-2.5 scrollbar-thin scrollbar-track-slate-50 scrollbar-thumb-[#133a69]/60">
              <div className="px-5 pb-2 text-[10px] text-slate-400 font-extrabold uppercase tracking-wider flex items-center justify-between border-b border-slate-100/60 mb-1">
                <span>Pages ({filteredPages.length})</span>
                <span className="text-[9px] text-[#133a69] font-medium normal-case">Type to search, click to navigate</span>
              </div>

              <div className="space-y-0.5 px-2">
                {filteredPages.length > 0 ? (
                  filteredPages.map((page) => {
                    let emoji = "📄";
                    const pLower = page.name.toLowerCase();
                    if (pLower.includes("home")) emoji = "🏠";
                    else if (pLower.includes("task")) emoji = "📝";
                    else if (pLower.includes("member") || pLower.includes("customer")) emoji = "👥";
                    else if (pLower.includes("payroll")) emoji = "💰";
                    else if (pLower.includes("attendance")) emoji = "📅";
                    else if (pLower.includes("report")) emoji = "📊";
                    else if (pLower.includes("whatsapp")) emoji = "💬";
                    else if (pLower.includes("setup") || pLower.includes("plan") || pLower.includes("update")) emoji = "⚙️";
                    else if (pLower.includes("leave") || pLower.includes("request")) emoji = "🌴";

                    return (
                      <button
                        key={page.path}
                        onClick={() => {
                          navigate(page.path);
                          setIsPageModalOpen(false);
                          setPageSearchQuery("");
                        }}
                        className="w-full text-left px-4 py-3 rounded-xl text-slate-700 hover:text-[#133a69] hover:bg-[#133a69]/5 hover:translate-x-1.5 transition-all duration-200 flex items-center justify-between font-bold cursor-pointer group"
                      >
                        <div className="flex items-center gap-3.5 min-w-0">
                          <span className="text-lg group-hover:scale-115 transition-transform">{emoji}</span>
                          <span className="truncate text-sm tracking-wide">{page.name}</span>
                        </div>
                        <span className="text-[10px] text-slate-400 group-hover:text-[#133a69] font-mono transition-colors shrink-0 bg-[#f3f8fb] px-2 py-0.5 rounded-lg border border-slate-100">
                          {page.path}
                        </span>
                      </button>
                    );
                  })
                ) : (
                  <div className="py-12 text-center flex flex-col items-center justify-center text-slate-400 gap-2">
                    <span className="text-3xl">🔍</span>
                    <span className="text-xs italic font-medium">No matching pages found</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

    </header>
  );
};

export default Header;
